import { render } from "./ContactForm.vue?vue&type=template&id=6bb26ae2"
import script from "./ContactForm.vue?vue&type=script&lang=js"
export * from "./ContactForm.vue?vue&type=script&lang=js"

import "./ContactForm.vue?vue&type=style&index=0&id=6bb26ae2&lang=scss"

import exportComponent from "/codebuild/output/src719114813/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__